import { CHAT_MESSAGE_CHOICES } from '../constants/constants'
import type { ChatbotMessage } from '../types/messageTypes'

export const getHasChoiceMessage = (chatHistoryMessages: ChatbotMessage[]) =>
	chatHistoryMessages.some((message) =>
		CHAT_MESSAGE_CHOICES.includes(message.type)
	)
